export const APP_NAME = "Nexus HR";
export const APP_URL = "https://nexushr.tech";

export const SOCIAL_LINKS = {
  FACEBOOK: "https://www.facebook.com/profile.php?id=61575010856485",
  INSTAGRAM: "https://www.instagram.com/nexushr.cr/",
  LINKEDIN: "https://www.linkedin.com/company/nexus-hr-costa-rica/",
};

export const EXTERNAL_LINKS = {
  APP_LOGIN: "https://app.nexushr.tech/login",
  JOBS_PORTAL: "https://jobs.nexushr.tech/",
  BLOG: "https://la-voz-del-talento-nexus.lovable.app/",
  SALARY_CALCULATOR: "https://salary-calculator-costa-rica.lovable.app/",
  CONTACT_FORM: "https://forms.monday.com/forms/2d05af9fa7cd69fa052042ca431f1144?r=use1",
  CAREERS: "https://jobs.nexushr.tech/nexus-hr-tech-jrz7oqyl/",
  PERSONALIZED_QUOTE: "https://form.typeform.com/to/A00PByfP",
};

export const CONTACT_INFO = {
  WHATSAPP: "+506 8686-2011",
  EMAIL: "soporte@nexushrcr.com",
  HOURS: "Lunes a Viernes de 8am a 5pm",
};

// Navigation sections - keeping this in sync with actual DOM IDs
export const SECTIONS = {
  HOME: "inicio",
  CANDIDATES: "candidatos",
  COMPANIES: "empresas",
  FEATURES: "funcionalidades",
  PLANS: "planes",
  FAQS: "faqs",
  CONTACT: "contacto",
};

// Shared calendar URL for demo bookings - single source of truth
export const DEMO_CALENDAR_URL =
  "https://calendar.google.com/calendar/appointments/schedules/AcZssZ1vrrUUlhkQ9tRvf_pNHQoIThhSH34JARjS8cjx9ulcc9Lt7PwJvzExmLzYhU_qm-2cJ_B0kAhB?gv=true";
